export default {
  brand: {
    name: 'USFansLink',
  },
  nav: {
    home: 'Strona główna',
    guide: 'Przewodnik USFans Spreadsheet',
    shoppingGuide: 'Przewodnik zakupowy',
    categories: 'Kategorie',
    faq: 'FAQ',
    buyNow: 'Kup teraz',
    spread: 'USFans Spreadsheet',
  },
  lang: {
    label: 'Język',
    en: 'English',
    pl: 'Polski',
    es: 'Español',
    fr: 'Français',
  },
  trust: {
    independent: 'Niezależne źródło',
    updated: 'Regularnie aktualizowane',
    multilingual: 'Wielojęzyczne',
  },
  footer: {
    tagline: 'Niezależne źródło informacji dla użytkowników arkusza USFans.',
    explore: 'Odkrywaj',
    shop: 'Kategorie sklepu',
    mainSite: 'Odwiedź główną stronę',
    guide: 'Przeczytaj przewodnik',
    disclaimer: 'USFansLink jest niezależnym źródłem informacji. Nie gwarantujemy dostępności, autentyczności, jakości, ceny, realizacji wysyłki ani bezpieczeństwa żadnych produktów, sprzedawców czy usług osób trzecich. Zawsze samodzielnie weryfikuj ważne informacje przed zakupem.',
    rights: 'Wszelkie prawa zastrzeżone.',
  },
};